import React, { useEffect, useState } from "react";
import {
  NavLink,
  Outlet,
  useParams,
  useNavigate,
} from "react-router-dom";
import { fetchJobById } from "../../Redux/ActionCreators/jobsAction";
import { fetchIdibuStatus } from "../../Redux/ActionCreators/idibuAction";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Stage4InviteCandidates from "../CreateJob/InviteCandidates";
import { useAppPermission } from "../../hooks/useAppPermission";
import { P } from "../../constants/rbac";

const JobTabs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { jobId } = useParams();
  const { can } = useAppPermission();
  const canInviteCandidates = can(P.JOBS_CANDIDATE_CREATE);
  const canViewSettings = can(P.JOBS_SETTINGS_READ) || can(P.JOBS_SETTINGS_EDIT) || can(P.JOBS_JOB_EDIT);
  const canViewAutomation = can(P.JOBS_AUTOMATION_READ) || can(P.JOBS_AUTOMATION_EDIT) || can(P.JOBS_JOB_EDIT);

  const job = useSelector((state) => state.jobs.latestJob);

  const [showAddCandidates, setShowAddCandidates] = useState(false);
  const [titleLoading, setTitleLoading] = useState(false);
  const [idibuEnabled, setIdibuEnabled] = useState(false);

  useEffect(() => {
    const fetchJobData = async () => {
      if (jobId) {
        setTitleLoading(true);
        await dispatch(fetchJobById(jobId));
        setTitleLoading(false);
      }
    };
    fetchJobData();
  }, [dispatch, jobId]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const status = await dispatch(fetchIdibuStatus());
      if (mounted) {
        setIdibuEnabled(Boolean(status?.effective_enabled));
      }
    })();
    return () => {
      mounted = false;
    };
  }, [dispatch, jobId]);

  return (
    <div className="job-tabs">
      <div className="job-navigation">
        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
          <img
            src="/images/back-arrow-black.svg"
            alt=""
            onClick={() => navigate("/jobs")}
            style={{ cursor: "pointer" }}
          />
          {titleLoading ? (
            <div
              className="loading-overlay"
              style={{
                alignItems: "start",
                height: "auto",
                display: "flex",
                justifyContent: "start",
              }}
            >
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading job...</span>
              </div>
            </div>
          ) : (
            <h3>{job ? job.title : ""}</h3>
          )}
        </div>
        {canInviteCandidates && (
        <button
          className="add-candidate-btn"
          onClick={() => setShowAddCandidates(true)}
          disabled={showAddCandidates}
          style={showAddCandidates ? { cursor: "not-allowed", opacity: 0.5 } : {}}
        >
          Add Candidates
        </button>
        )}
      </div>
      <div className="tabs-header">
        <div className="d-flex tabs-items">
          <NavLink
            to={`/jobs/${jobId}/candidates`}
            className="tab-btn"
            onClick={showAddCandidates ? (e) => e.preventDefault() : undefined}
            style={showAddCandidates ? { cursor: "not-allowed", pointerEvents: "all" } : {}}
          >
            Candidates
          </NavLink>
          <NavLink
            to={`/jobs/${jobId}/details`}
            className="tab-btn"
            onClick={showAddCandidates ? (e) => e.preventDefault() : undefined}
            style={showAddCandidates ? { cursor: "not-allowed", pointerEvents: "all" } : {}}
          >
            Job Details
          </NavLink>
          {canViewSettings && (
          <NavLink
            to={`/jobs/${jobId}/settings`}
            className="tab-btn"
            onClick={showAddCandidates ? (e) => e.preventDefault() : undefined}
            style={showAddCandidates ? { cursor: "not-allowed", pointerEvents: "all" } : {}}
          >
            Job Settings
          </NavLink>
          )}
          {canViewAutomation && (
          <NavLink
            to={`/jobs/${jobId}/automation`}
            className="tab-btn"
            onClick={showAddCandidates ? (e) => e.preventDefault() : undefined}
            style={showAddCandidates ? { cursor: "not-allowed", pointerEvents: "all" } : {}}
          >
            Automation
          </NavLink>
          )}
          {idibuEnabled ? (
            <NavLink
              to={`/jobs/${jobId}/job-boards`}
              className="tab-btn"
              onClick={showAddCandidates ? (e) => e.preventDefault() : undefined}
              style={showAddCandidates ? { cursor: "not-allowed", pointerEvents: "all" } : {}}
            >
              Post to Job Boards
            </NavLink>
          ) : null}
        </div>
      </div>

      {/* Render Active Tab or Add Candidates panel */}
      <div className="tab-content">
        {showAddCandidates && canInviteCandidates ? (
          <Stage4InviteCandidates
            jobId={jobId}
            fromJobTabs={true}
            onBack={() => setShowAddCandidates(false)}
          />
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};

export default JobTabs;
